export default __webpack_public_path__ + "static/media/expired.a712528e.svg";